export default {
  //Hungarian hu(languagecode) HU(countrycode) Magyarország / Magyar
  LandingPage: {
    intro_sub:
      'Tegyél te is a környezetért, hasznosítsd újra a csomagolást!',
    title: 'Samsung környezetbarát csomagolás',
    sequence1_1: 'Csatlakozz hozzánk és csökkentsük',
    sequence1_2:
      'együtt hulladék mennyiségét a fenntarthatóbb környezetért, azzal, hogy a termék csomagolását hasznos tárgyakká alakítod. Görgess le az első lépésekhez!',
    sequence2_1: 'Bemutatjuk a Samsung környezetbarát csomagolását!',
    sequence2_2:
      'A TV dobozát úgy alakítottuk ki, hogy újrahasznosítható legyen és hozzájáruljon a környezetvédelemhez. Készíts különböző tárgyakat a termék csomagolásából!',
    sequence3_1: 'Kövesd a csomagoláson elhelyezett pontokat!',
    sequence3_2:
      'Vágd szét a dobozt az instrukciók szerint és készíts belőlük izgalmas tárgyakat!',
    sequence4_1: 'Válaszd ki a tárgyat, amit a dobozból szeretnél elkészíteni!',
    sequence4_2:
      'Görgess le és válaszd ki a termék modellt, amelynek doboza megtalálható nálad. Ezután válaszd ki a megfelelő opciót, majd kezdd el a megalkotni a kiválasztott tárgyat.',
    selectBox: 'Válaszd ki a termék típusát!',
    moreActivity:
      "További információk a Samsung fenntarthatósági aktivitásairól",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitorok', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Hangprojektor', //update
    Soundbar: 'Hangprojektor', //update
    SoundbarSet01:'Hangprojektor Set 1',
    SoundbarSet02:'Hangprojektor Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/hu/sustainability/overview/',
   // moreActivityLink:'https://www.samsung.com/hu/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/hu/sustainability/overview/',
    footer: `
    Copyright© 2019-2021 Samsung. Minden jog fenntartva.`,
  },
  ProductPage: {
    selectDesign: 'Válaszd ki a dizájnt!',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'TV konzol',
    StorageBox: 'Tárolódoboz',
    MagazineRack: 'Újságtartó',
    CatHouse: 'Cicaház',
    CatTunnel: 'Macskaalagút',
    BookShelf: 'Könyvespolc',
    DeskShelf: 'Asztali polc',
    BlackRhino: 'Veszélyeztetett\n állatok:\n fekete orrszarvú', //update
    PolarBear: 'Veszélyeztetett\n állatok:\n jegesmedve', //update
    SeaTurtle: 'Veszélyeztetett\n állatok:\n tengeri teknős', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Mozaik mintás', //update
    Twist: 'Csavart', //update
    AlexCouchArmTable: 'Alex kanapé,\n karos asztal', //update
    BlastOffClubHouse: 'Blast Off \n klubház', //update
    KinokoTable: 'Kinoko asztal', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Képeslaptartó', //update
    SneakerRack: 'Cipőtartó', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Eszköztartó', //update
    DeskStationary: 'Irodaszer',
    CoinBank: 'Érme bank',
    MobileScanner:'Okostelefon szkenner állvány',
    TabletScanner:'Táblagép szkenner állvány',
    PetStairs:'Kisállat lépcsők',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'perc',
    all:'ALL',
    in: 'alatt',
    inOnly: 'csak',
    allBoxSize: 'Minden dobozméret',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'utasítások',
    prepare: 'Készítsd elő a dobozt!',
    LetsDesign: "Kezdjük a kialakítással!",
    drawParts: 'Rajzolj a dobozra!',
    note1: 'Figyelem! A grafika elhelyezkedése országonként és a doboz méretétől függően eltérhet.',
    note2: 'Először vázold fel a teljes rajzot úgy, hogy elférjen a dobozon!',
    numberSpace: 'szám = pontok közötti hely',
    diagonal: 'átlós',
    LEFT: 'BAL (oldal)',
    RIGHT: 'JOBB (oldal)',
    TOP: 'FELSŐ (rész)',
    TOP1: 'FELSŐ (rész) 1',
    TOP2: 'FELSŐ (rész) 2',
    BACK: 'HÁTOLDAL (rész)',
    MIDDLE: 'KÖZÉPSŐ (rész)',
    MIDDLE2: 'KÖZÉPSŐ (rész) 2',
    BOTTOM: 'ALSÓ (rész)',
    FRONT: 'ELÜLSŐ (oldal)',
    SIDE: 'OLDALI (rész)',
    secondSIDE: 'MÁSODIK OLDAL (rész)',
    secondSIDE1: 'MÁSODIK OLDAL (rész) 1',
    secondSIDE2: 'MÁSODIK OLDAL (rész) 2',
    LEG: 'LÁB (rész)', //update
    JOINT: 'ÖSSZEKAPCSOLT (rész)', //update
    FACE: 'ARC (rész)', //update
    DRAWERBOTTOM: 'FIÓK ALSÓ (rész)', //update
    DRAWERSIDE: 'FIÓK OLDAL (rész)', //update
    NOSE: 'ORR (rész)', //update
    HANDLE: 'FOGGANTYÚ (rész)', //update
    BOTTOMSIDE: 'ALSÓ OLDAL (rész)', //update
    TOPSIDE: 'FELSŐ OLDAL (rész)', //update
    WING: 'SZÁRNY (rész)', //update
    cutAndAssemble: "Vágd ki és rakd össze!",
    beCareful: 'Légy óvatos vágóeszközzel, nehogy megsértsd magad!',
    cutOutParts: 'Vágd ki az egyes részeket!',
    assemble: 'Illeszd össze!',
    Assemblyguide: 'Összeszerelési útmutató', //update
    fold: 'Példa a hajlításra',
    foldGuide: 'Használd a bútorok széleit, amikor meghajlítod a kartont!',
    foldGuideDezeen:
      'A kartonpapír meghajlításához, nyomj a karton pontozott részeire néhányszor olyan tárgyakkal, amelyek segítik a hajlítást.', //update
    glue: 'Használj ragasztót vagy celluxot a felületen!', //update
    cable: 'Használj kábeleket vagy húrokat az összekapcsoláshoz!', //update
    done: 'Kész!',
    goBack: 'Vissza a főmenühöz',
  },
  CautionPage: {
    CAUTION: 'FIGYELMEZTETÉS!',
    needItem: 'A közvetkező elemekre szükséged lesz',
    children: 'A gyerekek kizárólag szülői felügyelettel végezzék a lépéseket!',
    mat:
      'Annak érdekében, hogy elkerüld a padlón keletkező karcolásokat, helyezz egy védőréteget a padlóra!',
    doNotPutHeavyThing:
      'Ne lépj rá és ne ülj rá ezekre a kartonból készült bútordarabora és ne helyezz rájuk nehéz tárgyakat!',
    doNotThrow:
      'Ne dobd se emberekhez, se állatokhoz ezeket a bútordarabokat és ne is rúgj beléjük!',
    stayAwayFlame: 'Lángtól és tűztől távol tartandó!',
    stayAwayWater: 'Óvd a víztől és a párától!',
    mayDamaged: '* Előfordulhat, hogy a TV doboza szállítás közben sérül.',
    companyDoestResponsible:
      '* A vállalat nem vállal felelősséget a tárgyak elkészítése közben keletkezett meghibásodásokért, sérülésekért.',
    cannotBeReturned:
      '* A sérült dobozokkal rendelkező termékek visszaküldésére nincs lehetőség abban az esetben, ha a termékben nem keletkezett kár.',
    understand: 'Rendben, megértette',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Törekedj a zöldebb jövőre!',
      text1:
        'Kevesebb papírt és tintát használtunk tévés csomagolásaink többségéhez, mint a korábbi csomagolásunkhoz, hogy fokozzuk elkötelezettségünket a fenntarthatóság iránt',
      text2:'',
      text2_special:
        '(* A fenti állítás nem vonatkoznak minden modellekre, beleértve a Lifestyle TV-ket is.)',
      text3: 'Válassz az alábbi gombok közül és tudj meg többet',
    },
    greenIn: {
      title: 'Törekedj a zöldebb jövőre, kezd a TV dobozánál!',
      subtitle1: 'Keress termékinformációra',
      subtitle2: 'Újrahasznosított környezettudatos csomagolás',
      desc: 'Keress modellre és tudj meg további részleteket',
      descM: '*Készíts fotó a TV modelled számáról',
      guide: 'modell neve',
      button: 'Fotó készítése',
      button2: 'Tovább a tárgyak készítéséhez',
      product_info: 'Termékinformáció',
    },
    search: {
      guide: 'Keresés..',
      noResult: 'Nincs találat',
      more: 'TOVÁBB',
      search: 'Keresés',
      retake: 'Új felvétel',
      result: 'Eredmény',
    },
    photo: {
      guide1: 'Helyezd a TV modelled nevét a dobozba',
      guide2: '(pl. Q800A, UT7000, RU7100, stb)',
    },
  },
  searchCountrySelect: 'Válaszd ki az országot a kereséshez'
};
